/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-unresolved */
import React from 'react'
import styled from 'styled-components'
import ParseContent from 'components/shared/ParseContent'

// Libraries
import parse from 'html-react-parser'

// Elements
import ButtonDefault from 'components/elements/ButtonDefault'
import RatingAlt from 'components/Reviews/RatingAlt'

//
import Input from './Input'

const ExpandButton = styled.div`
  font-size: ${(props) => props.theme.font.size.xm};
  font-weight: ${(props) => props.theme.font.weight.s};
`

const Block = styled.div`
  border: 2px solid
    ${(props) => (props.noBorder ? 'transparent' : props.theme.color.secondary)};
  border-radius: 25px;
`

const BlockTitle = styled.h3`
  font-weight: ${(props) => props.theme.font.weight.l};
  color: ${(props) => props.theme.color.text.secondary};
  margin: 0;

  @media (min-width: 992px) {
    font-size: ${(props) => props.theme.font.size.xl};
  }

  @media (min-width: 991px) {
    font-size: ${(props) => props.theme.font.size.xm};
  }
`

const ButtonInfo = styled.div`
  color: ${(props) => props.theme.color.text.secondary};
`

const StyledRatingAlt = styled(RatingAlt)`
  .row {
    margin: 0 !important;
  }
`

const Step1 = ({
  fields,
  formFields,
  setExpanded,
  expanded,
  setData,
  data,
  setFieldValue,
  setStep,
  validateForm,
  handleSubmit,
}) => {
  const from = formFields.filter(
    ({ inputName, visibility }) =>
      inputName === 'from' &&
      (parseFloat(expanded) === 1 ||
        (visibility === 'visible' && visibility !== 'hidden'))
  )
  const to = formFields.filter(
    ({ inputName, visibility }) =>
      inputName === 'to' &&
      (parseFloat(expanded) === 1 ||
        (visibility === 'visible' && visibility !== 'hidden'))
  )
  const volume = formFields.filter(
    ({ inputName, visibility }) =>
      inputName === 'volume' &&
      (parseFloat(expanded) === 1 ||
        (visibility === 'visible' && visibility !== 'hidden'))
  )
  const service = formFields.filter(
    ({ inputName, visibility }) =>
      inputName === 'service' &&
      (parseFloat(expanded) === 1 ||
        (visibility === 'visible' && visibility !== 'hidden'))
  )
  const rest = formFields.filter(
    ({ inputName, visibility }) =>
      inputName === '' &&
      (parseFloat(expanded) === 1 ||
        (visibility === 'visible' && visibility !== 'hidden'))
  )

  return (
    <div>
      <div className="row">
        <div className="col-md-6">
          <Block className="p-4">
            <BlockTitle>{fields.from_title}</BlockTitle>

            <div>
              {from.map((edges) => (
                <Input
                  key={edges.id}
                  edges={edges}
                  setData={setData}
                  data={data}
                  setFieldValue={setFieldValue}
                />
              ))}
            </div>
          </Block>
        </div>
        <div className="col-md-6 mt-4 mt-md-0">
          <Block className="p-4">
            <BlockTitle>{fields.to_title}</BlockTitle>

            <div>
              {to.map((edges) => (
                <Input
                  key={edges.id}
                  edges={edges}
                  setData={setData}
                  data={data}
                  setFieldValue={setFieldValue}
                />
              ))}
            </div>
          </Block>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-lg-6">
          <Block noBorder className="p-md-4">
            <div>
              {rest.map((edges) => (
                <Input
                  key={edges.id}
                  edges={edges}
                  setData={setData}
                  data={data}
                  setFieldValue={setFieldValue}
                />
              ))}
            </div>
          </Block>
        </div>
        <div className="col-lg-6">
          <Block noBorder className="p-md-4">
            <div>
              {volume.map((edges) => (
                <Input
                  key={edges.id}
                  edges={edges}
                  setData={setData}
                  data={data}
                  setFieldValue={setFieldValue}
                />
              ))}
            </div>
          </Block>
        </div>
      </div>

      {parseFloat(expanded) === 1 && (
        <>
          <div className="row mt-5 mt-md-4">
            <div className="col-lg-6">
              <ParseContent content={fields.expaned_description} />
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6">
              {service.map((edges) => (
                <Input
                  key={edges.id}
                  edges={edges}
                  setData={setData}
                  data={data}
                  setFieldValue={setFieldValue}
                />
              ))}
            </div>
          </div>
        </>
      )}

      <div className="row mt-5">
        <div className="col-lg-6">
          {parseFloat(expanded) === 0 && (
            <ExpandButton
              role="button"
              onClick={() => {
                setExpanded(1)
              }}
            >
              {parse(fields.expand_description_out)}
            </ExpandButton>
          )}

          {parseFloat(expanded) === 1 && (
            <ExpandButton
              role="button"
              onClick={() => {
                setExpanded(0)
              }}
            >
              {parse(fields.expand_description_in)}
            </ExpandButton>
          )}
        </div>
        <div className="col-lg-6 d-flex align-items-center justify-content-end">
          <div className="text-right">
            <ButtonDefault
              isCustom
              type="next"
              onClick={() => {
                validateForm().then((errors) => {
                  if (Object.keys(errors).length === 0) {
                    setStep(2)
                  } else {
                    handleSubmit()
                  }
                })
              }}
            >
              {fields.button_next}
            </ButtonDefault>
            <ButtonInfo className="mt-3 font-size-xm font-weight-s mb-4">
              <ParseContent content={fields.button_next_info} />
            </ButtonInfo>
            <StyledRatingAlt noTitle />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Step1
